export enum RepairChannel {
  CustomerSelfService = "CustomerSelfService",
  ERGO = "ERGO",
  Northgate = "Northgate",
  ColleagueSelfServe = "ColleagueSelfService",
  Automated = "Automated",
  TotalConnect="TotalConnect"
}